var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"操作错误提示"},on:{"ok":_vm.handleOk},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }